import { useState, Dispatch, SetStateAction, useMemo } from 'react';

export interface ToggleHandlers {
  toggle: () => void;
  turnOn: () => void;
  turnOff: () => void;
  setIsOn: Dispatch<SetStateAction<boolean>>;
}

export function useToggleV2(defaultState = false): [boolean, ToggleHandlers] {
  const [isOn, setIsOn] = useState(defaultState);

  const actions = useMemo(
    () => ({
      toggle: () => setIsOn((pastVisibility) => !pastVisibility),
      turnOn: () => setIsOn(true),
      turnOff: () => setIsOn(false),
      setIsOn,
    }),
    [],
  );

  // destructuring the array is part of the usage of this
  // hook format, therefore we do not need to memorize it
  // only if it was an object, which would get recreated on EVERY render
  return [isOn, actions] as [boolean, ToggleHandlers];
}

/*
 -------- Explanation --------

  In JS if we de-structure an array, we actually
  get the reference out of the array

  Which means

  const [isOn, handlers] = useToggleState()

  handlers will ALWAYS point to the same memory ref

  same as each and every function inside of it:

  const [isOn, { toggle }] = useToggleState()

  Toggle is always true, and sage to be used to dependency arrays
*/
